import { FirebaseConfig } from './FirebaseConfig.js';

/**
 * Get a firebase app by name.
 *
 * WARNING: `FirebaseApp().database().ref()` should not be used in place of `FirebaseWorker.database().ref()`
 * where update parsing or mobile support is required.
 * @param {string} [name='[DEFAULT]'] - The name of the app to get.
 * @returns {object} The firebase app.
 */
export function FirebaseApp(name = '[DEFAULT]') {
  // Get global firebase (client side) or load the admin SDK (server side).
  const firebase = globalThis?.firebase ?? require?.('firebase-admin');
  if (!firebase) throw new Error('Failed to load firebase');
  // Return the necessary firebase app.
  return firebase.apps.find((x) => x.name == name) ?? firebase.initializeApp(FirebaseConfig(name), name);
}
